import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from '../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { InformixLinkedService } from 'app/model/linkedservice/informix.linkedservice';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { IModel } from 'app/model/base/annotation';
import { parameterizablePasswordOrAKVtoSecretBase, parameterizableSecretBaseToModel} from './azure-key-vault.util';
import { ValueAdapter } from '../value.adapter';
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(InformixLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                connectionString: 'secret',
                authenticationType: '*',
                userName: '*',
                password: 'secret',
                credential: 'secret',
                encryptedCredential: '*'
            },
            parameters: '*'
        }
    }
})
export class InformixLinkedServiceAdapter extends LinkedServiceAdapter<InformixLinkedService> {
    protected supportFirstClassParameterExperience = true;
    protected modelConstructor(): new () => InformixLinkedService {
        return InformixLinkedService;
    }

    protected model(): IModel {
        return InformixLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: InformixLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.OdbcLinkedService;
        properties.type = Metamodel.modelFor(InformixLinkedService).name;

        const connectionString: string | Model.SecretBase = parameterizablePasswordOrAKVtoSecretBase(linkedService, InformixLinkedService.CONNECTION_STRING, this.context);
        const userName: string = linkedService.authenticationType === 'Basic' ? this.valueToResource(linkedService, InformixLinkedService.USER_NAME) : undefined;
        const password: string | Model.SecretBase = linkedService.authenticationType === 'Basic' ? parameterizablePasswordOrAKVtoSecretBase(linkedService, InformixLinkedService.PASSOWRD, this.context) : undefined;
        const credential: string | Model.SecretBase = linkedService.credential ? parameterizablePasswordOrAKVtoSecretBase(linkedService, InformixLinkedService.CREDENTIAL, this.context) : undefined;

        properties.typeProperties = {
            connectionString,
            authenticationType: linkedService.authenticationType,
            userName,
            password,
            credential
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(modelLinkedServiceResource: Model.LinkedServiceResource, linkedService: InformixLinkedService): Promise<InformixLinkedService> {
        const properties = modelLinkedServiceResource.properties as Model.OdbcLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.OdbcLinkedServiceTypeProperties = properties.typeProperties;
        parameterizableSecretBaseToModel(linkedService, InformixLinkedService.CONNECTION_STRING, typeProperties.connectionString, this.context, true);
        ValueAdapter.toModel(linkedService, InformixLinkedService.USER_NAME, typeProperties.userName);
        parameterizableSecretBaseToModel(linkedService, InformixLinkedService.PASSOWRD, typeProperties.password, this.context, linkedService.authenticationType === 'Basic');
        parameterizableSecretBaseToModel(linkedService, InformixLinkedService.CREDENTIAL, typeProperties.credential, this.context, true);
        linkedService.authenticationType = typeProperties.authenticationType;
        return linkedService;
    }
}
